export default "__VITE_ASSET__d55aa52d__"